 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML9780292747500_01_COVER from '@/components/html/9780292747500_01_cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML9780292747500_02_TIT from '@/components/html/9780292747500_02_tit'
 import HTML9780292747500_03_CPY from '@/components/html/9780292747500_03_cpy'
 import HTML9780292747500_04_TOC from '@/components/html/9780292747500_04_toc'
 import HTML9780292747500_05_ACK from '@/components/html/9780292747500_05_ack'
 import HTML9780292747500_07_INT from '@/components/html/9780292747500_07_int'
 import HTML9780292747500_08_CH1 from '@/components/html/9780292747500_08_ch1'
 import HTML9780292747500_09_CH2 from '@/components/html/9780292747500_09_ch2'
 import HTML9780292747500_10_CH3 from '@/components/html/9780292747500_10_ch3'
 import HTML9780292747500_11_CH4 from '@/components/html/9780292747500_11_ch4'
 import HTML9780292747500_12_CH5 from '@/components/html/9780292747500_12_ch5'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML9780292747500_13_CONC from '@/components/html/9780292747500_13_conc'
 import HTML9780292747500_14_TIM from '@/components/html/9780292747500_14_tim'
 import HTML9780292747500_15_NOT from '@/components/html/9780292747500_15_not'
 import HTML9780292747500_16_BIB from '@/components/html/9780292747500_16_bib'
 import HTML9780292747500_17_IDX from '@/components/html/9780292747500_17_idx'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/9780292747500_04_toc",
 			"name" : "html/9780292747500_04_toc",
 			"component" : HTML9780292747500_04_TOC
 		},
 		{
 			"path" : "/html/9780292747500_05_ack",
 			"name" : "html/9780292747500_05_ack",
 			"component" : HTML9780292747500_05_ACK
 		},
 		{
 			"path" : "/html/9780292747500_07_int",
 			"name" : "html/9780292747500_07_int",
 			"component" : HTML9780292747500_07_INT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js